import { render, staticRenderFns } from "./activity-library-dcf-actions-header.vue?vue&type=template&id=3861a922&scoped=true&"
import script from "./activity-library-dcf-actions-header.vue?vue&type=script&lang=js&"
export * from "./activity-library-dcf-actions-header.vue?vue&type=script&lang=js&"
import style0 from "./activity-library-dcf-actions-header.vue?vue&type=style&index=0&id=3861a922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861a922",
  null
  
)

component.options.__file = "activity-library-dcf-actions-header.vue"
export default component.exports